// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*

MIT License

Copyright (c) 2022 Bioregional Education Association

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

*/


/* configure vars */
.op-flex {
    --op-flex-gap-vertical: 10px;
    --op-flex-gap-horizontal: 10px;
    --op-flex-split-colour: #ddd;
    --op-flex-split-width: 1px;
}


/* reset all flex items */
.op-flex > * {
    flex-grow: 0;
    flex-shrink: 1;
}


/* alignment properties for items */
.op-flex > .flex-align-self-start {
    align-self: flex-start;
}

.op-flex > .flex-align-self-end {
    align-self: flex-end;
}

.op-flex > .flex-align-self-center {
    align-self: center;
}

.op-flex > .flex-align-self-stretch {
    align-self: stretch;
}

.op-flex > .flex-align-self-baseline {
    align-self: baseline;
}

.op-flex > .flex-align-self-normal {
    align-self: normal;
}


/* stretch items to create equal width columns */
.op-flex.flex-stretch > * {
    width: 100%;
    flex-basis: 0px;
    flex-grow: 1;
}

.op-flex.flex-stretch {
    width: 100%;
}

.op-flex.flex-stretch > .op-flex.flex-stretch {
    width: auto;
}


/* general flex properties for items */
.op-flex.flex-grow-all > * {
    flex-grow: 1;
}

.op-flex > .flex-base {
    flex-basis: 0px;
}

.op-flex > .flex-base-auto {
    flex-basis: auto;
}

.op-flex > .flex-grow {
    flex-grow: 1;
}

.op-flex > .flex-shrink {
    flex-shrink: 1;
}

.op-flex > .flex-grow-none {
    flex-grow: 0;
}

.op-flex > .flex-shrink-none {
    flex-shrink: 0;
}


/* apply a gap, deliberately using the opposite side than 'flex-gap' */
.op-flex.flex-pad > *,
.op-flex.flex-pad-vertical > * {
    margin-bottom: var(--op-flex-gap-vertical);
}

.op-flex.flex-pad > *,
.op-flex.flex-pad-horizontal > * {
    margin-right: var(--op-flex-gap-horizontal);
}


/* apply padding to only top/left of container, letting the margins handle bottom/right */
.op-flex.flex-pad,
.op-flex.flex-pad-vertical {
    padding-top: var(--op-flex-gap-vertical);
    padding-bottom: 0px;
}

.op-flex.flex-pad,
.op-flex.flex-pad-horizontal {
    padding-left: var(--op-flex-gap-horizontal);
    padding-right: 0px;
}


/* remove pad from single items */
.op-flex > .flex-pad-none,
.op-flex.flex-pad > .flex-pad-none,
.op-flex > .flex-pad-vertical-none,
.op-flex.flex-pad > .flex-pad-vertical-none {
    margin-bottom: 0px;
}

.op-flex > .flex-pad-none,
.op-flex.flex-pad > .flex-pad-none,
.op-flex > .flex-pad-horizontal-none,
.op-flex.flex-pad > .flex-pad-horizontal-none {
    margin-right: 0px;
}


/* apply pad to single items */
.op-flex > .flex-pad-top {
    padding-top: var(--op-flex-gap-vertical);
}

.op-flex > .flex-pad-left {
    padding-left: var(--op-flex-gap-horizontal);
}

.op-flex > .flex-pad-bottom {
    padding-bottom: var(--op-flex-gap-vertical);
}

.op-flex > .flex-pad-right {
    padding-right: var(--op-flex-gap-horizontal);
}

.op-flex > .flex-pad-self-vertical {
    padding-top: var(--op-flex-gap-vertical);
    padding-bottom: var(--op-flex-gap-vertical);
}

.op-flex > .flex-pad-self-horizontal {
    padding-left: var(--op-flex-gap-horizontal);
    padding-right: var(--op-flex-gap-horizontal);
}


/* apply gap to all but the first child */
.op-flex.flex-gap.flex-vertical > *:not(:first-child),
.op-flex.flex-gap-vertical > *:not(:first-child) {
    margin-top: var(--op-flex-gap-vertical);
}

.op-flex.flex-gap:not(.flex-vertical) > *:not(:first-child),
.op-flex.flex-gap-horizontal > *:not(:first-child) {
    margin-left: var(--op-flex-gap-horizontal);
}


/* apply negative margins to container only when also using 'flex-wrap' */
.op-flex.flex-gap.flex-wrap {
    margin-top: calc(-1 * var(--op-flex-gap-vertical));
    margin-left: calc(-1 * var(--op-flex-gap-horizontal));
}

.op-flex.flex-gap.flex-wrap > * {
    margin-top: var(--op-flex-gap-vertical);
    margin-left: var(--op-flex-gap-horizontal);
}


/* remove gap from single items */
.op-flex.flex-vertical > .flex-gap-none,
.op-flex.flex-gap.flex-vertical > .flex-gap-none,
.op-flex > .flex-gap-vertical-none,
.op-flex.flex-gap > .flex-gap-vertical-none {
    margin-top: 0px;
}

.op-flex:not(.flex-vertical) > .flex-gap-none,
.op-flex.flex-gap:not(.flex-vertical) > .flex-gap-none,
.op-flex > .flex-gap-horizontal-none,
.op-flex.flex-gap > .flex-gap-horizontal-none {
    margin-left: 0px;
}


/* apply gap to single items */
.op-flex > .flex-gap-top {
    margin-top: var(--op-flex-gap-vertical);
}

.op-flex > .flex-gap-left {
    margin-left: var(--op-flex-gap-horizontal);
}

.op-flex > .flex-gap-bottom {
    margin-bottom: var(--op-flex-gap-vertical);
}

.op-flex > .flex-gap-right {
    margin-right: var(--op-flex-gap-horizontal);
}


/* push items using auto margins. applied here to override gaps */
.op-flex.flex-vertical > .flex-top,
.op-flex.flex-pad.flex-vertical > .flex-top,
.op-flex.flex-vertical:not(.flex-reverse) > .flex-self-start,
.op-flex.flex-vertical.flex-reverse > .flex-self-end {
    margin-bottom: auto;
}

.op-flex:not(.flex-vertical) > .flex-left,
.op-flex.flex-pad:not(.flex-vertical) > .flex-left,
.op-flex:not(.flex-vertical):not(.flex-reverse) > .flex-self-start,
.op-flex:not(.flex-vertical).flex-reverse > .flex-self-end {
    margin-right: auto;
}

.op-flex.flex-vertical > .flex-bottom,
.op-flex.flex-gap.flex-vertical > .flex-bottom,
.op-flex.flex-vertical:not(.flex-reverse) > .flex-self-end,
.op-flex.flex-vertical.flex-reverse > .flex-self-start {
    margin-top: auto;
}

.op-flex:not(.flex-vertical) > .flex-right,
.op-flex.flex-gap:not(.flex-vertical) > .flex-right,
.op-flex:not(.flex-vertical):not(.flex-reverse) > .flex-self-end,
.op-flex:not(.flex-vertical).flex-reverse > .flex-self-start {
    margin-left: auto;
}


/* split borders between items */
.op-flex.flex-split.flex-vertical > *:not(:last-child) {
    border-bottom: solid var(--op-flex-split-width) var(--op-flex-split-colour);
}

.op-flex.flex-split.flex-gap.flex-vertical > *:not(:last-child),
.op-flex.flex-split.flex-pad.flex-vertical > *:not(:last-child) {
    padding-bottom: var(--op-flex-gap-vertical);
}

.op-flex.flex-split:not(.flex-vertical) > *:not(:last-child) {
    border-right: solid var(--op-flex-split-width) var(--op-flex-split-colour);
}

.op-flex.flex-split.flex-gap:not(.flex-vertical) > *:not(:last-child),
.op-flex.flex-split.flex-pad:not(.flex-vertical) > *:not(:last-child) {
    padding-right: var(--op-flex-gap-horizontal);
}


/* invisible separator elements, used in place of auto margins on items */
.op-flex > .flex-space {
    margin: auto;
    padding: 0px;
    width: 0px;
    height: 0px;
    visibility: hidden;
}


/* default flex properties, for resetting items nested within other 'op-flex' containers */
.op-flex {
    display: flex;
    flex-basis: auto;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: normal;
    justify-content: normal;
    min-width: 0px;
}


/* special flex properties that control flow */
.op-flex.flex-vertical {
    flex-direction: column;
}

.op-flex.flex-reverse {
    flex-direction: row-reverse;
}

.op-flex.flex-vertical.flex-reverse {
    flex-direction: column-reverse;
}

.op-flex.flex-wrap {
    flex-wrap: wrap;
}

.op-flex.flex-wide {
    width: 100%;
}


/* apply both justify and align in 'flex-center', for convenience */
.op-flex.flex-center {
    justify-content: center;
    align-items: center;
}


/* container level justification properties. the 'just' keyword is left out of most selectors for ease of use */
.op-flex.flex-start {
    justify-content: flex-start;
}

.op-flex.flex-end {
    justify-content: flex-end;
}

.op-flex.flex-between {
    justify-content: space-between;
}

.op-flex.flex-even {
    justify-content: space-evenly;
}

.op-flex.flex-around {
    justify-content: space-around;
}

.op-flex.flex-just-center {
    justify-content: center;
}

.op-flex.flex-just-stretch {
    justify-content: stretch;
}

.op-flex.flex-just-normal {
    justify-content: normal;
}


/* container level alignment properties */
.op-flex.flex-align-start {
    align-items: flex-start;
}

.op-flex.flex-align-end {
    align-items: flex-end;
}

.op-flex.flex-align-center {
    align-items: center;
}

.op-flex.flex-align-stretch {
    align-items: stretch;
}

.op-flex.flex-align-baseline {
    align-items: baseline;
}

.op-flex.flex-align-normal {
    align-items: normal;
}
`, "",{"version":3,"sources":["webpack://./src/op-flex-mod.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC;;;AAGD,mBAAmB;AACnB;IACI,4BAA4B;IAC5B,8BAA8B;IAC9B,4BAA4B;IAC5B,0BAA0B;AAC9B;;;AAGA,yBAAyB;AACzB;IACI,YAAY;IACZ,cAAc;AAClB;;;AAGA,mCAAmC;AACnC;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA,gDAAgD;AAChD;IACI,WAAW;IACX,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;;AAGA,sCAAsC;AACtC;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;;AAGA,sEAAsE;AACtE;;IAEI,0CAA0C;AAC9C;;AAEA;;IAEI,2CAA2C;AAC/C;;;AAGA,yFAAyF;AACzF;;IAEI,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;;IAEI,2CAA2C;IAC3C,kBAAkB;AACtB;;;AAGA,iCAAiC;AACjC;;;;IAII,kBAAkB;AACtB;;AAEA;;;;IAII,iBAAiB;AACrB;;;AAGA,8BAA8B;AAC9B;IACI,wCAAwC;AAC5C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,wCAAwC;IACxC,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;IAC3C,4CAA4C;AAChD;;;AAGA,yCAAyC;AACzC;;IAEI,uCAAuC;AAC3C;;AAEA;;IAEI,0CAA0C;AAC9C;;;AAGA,yEAAyE;AACzE;IACI,kDAAkD;IAClD,qDAAqD;AACzD;;AAEA;IACI,uCAAuC;IACvC,0CAA0C;AAC9C;;;AAGA,iCAAiC;AACjC;;;;IAII,eAAe;AACnB;;AAEA;;;;IAII,gBAAgB;AACpB;;;AAGA,8BAA8B;AAC9B;IACI,uCAAuC;AAC3C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,2CAA2C;AAC/C;;;AAGA,iEAAiE;AACjE;;;;IAII,mBAAmB;AACvB;;AAEA;;;;IAII,kBAAkB;AACtB;;AAEA;;;;IAII,gBAAgB;AACpB;;AAEA;;;;IAII,iBAAiB;AACrB;;;AAGA,gCAAgC;AAChC;IACI,2EAA2E;AAC/E;;AAEA;;IAEI,2CAA2C;AAC/C;;AAEA;IACI,0EAA0E;AAC9E;;AAEA;;IAEI,4CAA4C;AAChD;;;AAGA,yEAAyE;AACzE;IACI,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;;AAGA,0FAA0F;AAC1F;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;;AAGA,8CAA8C;AAC9C;IACI,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;;AAGA,mEAAmE;AACnE;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA,+GAA+G;AAC/G;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;AAC3B;;;AAGA,yCAAyC;AACzC;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["/*\n\nMIT License\n\nCopyright (c) 2022 Bioregional Education Association\n\nPermission is hereby granted, free of charge, to any person obtaining a copy\nof this software and associated documentation files (the \"Software\"), to deal\nin the Software without restriction, including without limitation the rights\nto use, copy, modify, merge, publish, distribute, sublicense, and/or sell\ncopies of the Software, and to permit persons to whom the Software is\nfurnished to do so, subject to the following conditions:\n\nThe above copyright notice and this permission notice shall be included in all\ncopies or substantial portions of the Software.\n\nTHE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\nIMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\nFITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\nAUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\nLIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\nOUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\nSOFTWARE.\n\n*/\n\n\n/* configure vars */\n.op-flex {\n    --op-flex-gap-vertical: 10px;\n    --op-flex-gap-horizontal: 10px;\n    --op-flex-split-colour: #ddd;\n    --op-flex-split-width: 1px;\n}\n\n\n/* reset all flex items */\n.op-flex > * {\n    flex-grow: 0;\n    flex-shrink: 1;\n}\n\n\n/* alignment properties for items */\n.op-flex > .flex-align-self-start {\n    align-self: flex-start;\n}\n\n.op-flex > .flex-align-self-end {\n    align-self: flex-end;\n}\n\n.op-flex > .flex-align-self-center {\n    align-self: center;\n}\n\n.op-flex > .flex-align-self-stretch {\n    align-self: stretch;\n}\n\n.op-flex > .flex-align-self-baseline {\n    align-self: baseline;\n}\n\n.op-flex > .flex-align-self-normal {\n    align-self: normal;\n}\n\n\n/* stretch items to create equal width columns */\n.op-flex.flex-stretch > * {\n    width: 100%;\n    flex-basis: 0px;\n    flex-grow: 1;\n}\n\n.op-flex.flex-stretch {\n    width: 100%;\n}\n\n.op-flex.flex-stretch > .op-flex.flex-stretch {\n    width: auto;\n}\n\n\n/* general flex properties for items */\n.op-flex.flex-grow-all > * {\n    flex-grow: 1;\n}\n\n.op-flex > .flex-base {\n    flex-basis: 0px;\n}\n\n.op-flex > .flex-base-auto {\n    flex-basis: auto;\n}\n\n.op-flex > .flex-grow {\n    flex-grow: 1;\n}\n\n.op-flex > .flex-shrink {\n    flex-shrink: 1;\n}\n\n.op-flex > .flex-grow-none {\n    flex-grow: 0;\n}\n\n.op-flex > .flex-shrink-none {\n    flex-shrink: 0;\n}\n\n\n/* apply a gap, deliberately using the opposite side than 'flex-gap' */\n.op-flex.flex-pad > *,\n.op-flex.flex-pad-vertical > * {\n    margin-bottom: var(--op-flex-gap-vertical);\n}\n\n.op-flex.flex-pad > *,\n.op-flex.flex-pad-horizontal > * {\n    margin-right: var(--op-flex-gap-horizontal);\n}\n\n\n/* apply padding to only top/left of container, letting the margins handle bottom/right */\n.op-flex.flex-pad,\n.op-flex.flex-pad-vertical {\n    padding-top: var(--op-flex-gap-vertical);\n    padding-bottom: 0px;\n}\n\n.op-flex.flex-pad,\n.op-flex.flex-pad-horizontal {\n    padding-left: var(--op-flex-gap-horizontal);\n    padding-right: 0px;\n}\n\n\n/* remove pad from single items */\n.op-flex > .flex-pad-none,\n.op-flex.flex-pad > .flex-pad-none,\n.op-flex > .flex-pad-vertical-none,\n.op-flex.flex-pad > .flex-pad-vertical-none {\n    margin-bottom: 0px;\n}\n\n.op-flex > .flex-pad-none,\n.op-flex.flex-pad > .flex-pad-none,\n.op-flex > .flex-pad-horizontal-none,\n.op-flex.flex-pad > .flex-pad-horizontal-none {\n    margin-right: 0px;\n}\n\n\n/* apply pad to single items */\n.op-flex > .flex-pad-top {\n    padding-top: var(--op-flex-gap-vertical);\n}\n\n.op-flex > .flex-pad-left {\n    padding-left: var(--op-flex-gap-horizontal);\n}\n\n.op-flex > .flex-pad-bottom {\n    padding-bottom: var(--op-flex-gap-vertical);\n}\n\n.op-flex > .flex-pad-right {\n    padding-right: var(--op-flex-gap-horizontal);\n}\n\n.op-flex > .flex-pad-self-vertical {\n    padding-top: var(--op-flex-gap-vertical);\n    padding-bottom: var(--op-flex-gap-vertical);\n}\n\n.op-flex > .flex-pad-self-horizontal {\n    padding-left: var(--op-flex-gap-horizontal);\n    padding-right: var(--op-flex-gap-horizontal);\n}\n\n\n/* apply gap to all but the first child */\n.op-flex.flex-gap.flex-vertical > *:not(:first-child),\n.op-flex.flex-gap-vertical > *:not(:first-child) {\n    margin-top: var(--op-flex-gap-vertical);\n}\n\n.op-flex.flex-gap:not(.flex-vertical) > *:not(:first-child),\n.op-flex.flex-gap-horizontal > *:not(:first-child) {\n    margin-left: var(--op-flex-gap-horizontal);\n}\n\n\n/* apply negative margins to container only when also using 'flex-wrap' */\n.op-flex.flex-gap.flex-wrap {\n    margin-top: calc(-1 * var(--op-flex-gap-vertical));\n    margin-left: calc(-1 * var(--op-flex-gap-horizontal));\n}\n\n.op-flex.flex-gap.flex-wrap > * {\n    margin-top: var(--op-flex-gap-vertical);\n    margin-left: var(--op-flex-gap-horizontal);\n}\n\n\n/* remove gap from single items */\n.op-flex.flex-vertical > .flex-gap-none,\n.op-flex.flex-gap.flex-vertical > .flex-gap-none,\n.op-flex > .flex-gap-vertical-none,\n.op-flex.flex-gap > .flex-gap-vertical-none {\n    margin-top: 0px;\n}\n\n.op-flex:not(.flex-vertical) > .flex-gap-none,\n.op-flex.flex-gap:not(.flex-vertical) > .flex-gap-none,\n.op-flex > .flex-gap-horizontal-none,\n.op-flex.flex-gap > .flex-gap-horizontal-none {\n    margin-left: 0px;\n}\n\n\n/* apply gap to single items */\n.op-flex > .flex-gap-top {\n    margin-top: var(--op-flex-gap-vertical);\n}\n\n.op-flex > .flex-gap-left {\n    margin-left: var(--op-flex-gap-horizontal);\n}\n\n.op-flex > .flex-gap-bottom {\n    margin-bottom: var(--op-flex-gap-vertical);\n}\n\n.op-flex > .flex-gap-right {\n    margin-right: var(--op-flex-gap-horizontal);\n}\n\n\n/* push items using auto margins. applied here to override gaps */\n.op-flex.flex-vertical > .flex-top,\n.op-flex.flex-pad.flex-vertical > .flex-top,\n.op-flex.flex-vertical:not(.flex-reverse) > .flex-self-start,\n.op-flex.flex-vertical.flex-reverse > .flex-self-end {\n    margin-bottom: auto;\n}\n\n.op-flex:not(.flex-vertical) > .flex-left,\n.op-flex.flex-pad:not(.flex-vertical) > .flex-left,\n.op-flex:not(.flex-vertical):not(.flex-reverse) > .flex-self-start,\n.op-flex:not(.flex-vertical).flex-reverse > .flex-self-end {\n    margin-right: auto;\n}\n\n.op-flex.flex-vertical > .flex-bottom,\n.op-flex.flex-gap.flex-vertical > .flex-bottom,\n.op-flex.flex-vertical:not(.flex-reverse) > .flex-self-end,\n.op-flex.flex-vertical.flex-reverse > .flex-self-start {\n    margin-top: auto;\n}\n\n.op-flex:not(.flex-vertical) > .flex-right,\n.op-flex.flex-gap:not(.flex-vertical) > .flex-right,\n.op-flex:not(.flex-vertical):not(.flex-reverse) > .flex-self-end,\n.op-flex:not(.flex-vertical).flex-reverse > .flex-self-start {\n    margin-left: auto;\n}\n\n\n/* split borders between items */\n.op-flex.flex-split.flex-vertical > *:not(:last-child) {\n    border-bottom: solid var(--op-flex-split-width) var(--op-flex-split-colour);\n}\n\n.op-flex.flex-split.flex-gap.flex-vertical > *:not(:last-child),\n.op-flex.flex-split.flex-pad.flex-vertical > *:not(:last-child) {\n    padding-bottom: var(--op-flex-gap-vertical);\n}\n\n.op-flex.flex-split:not(.flex-vertical) > *:not(:last-child) {\n    border-right: solid var(--op-flex-split-width) var(--op-flex-split-colour);\n}\n\n.op-flex.flex-split.flex-gap:not(.flex-vertical) > *:not(:last-child),\n.op-flex.flex-split.flex-pad:not(.flex-vertical) > *:not(:last-child) {\n    padding-right: var(--op-flex-gap-horizontal);\n}\n\n\n/* invisible separator elements, used in place of auto margins on items */\n.op-flex > .flex-space {\n    margin: auto;\n    padding: 0px;\n    width: 0px;\n    height: 0px;\n    visibility: hidden;\n}\n\n\n/* default flex properties, for resetting items nested within other 'op-flex' containers */\n.op-flex {\n    display: flex;\n    flex-basis: auto;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: normal;\n    justify-content: normal;\n    min-width: 0px;\n}\n\n\n/* special flex properties that control flow */\n.op-flex.flex-vertical {\n    flex-direction: column;\n}\n\n.op-flex.flex-reverse {\n    flex-direction: row-reverse;\n}\n\n.op-flex.flex-vertical.flex-reverse {\n    flex-direction: column-reverse;\n}\n\n.op-flex.flex-wrap {\n    flex-wrap: wrap;\n}\n\n.op-flex.flex-wide {\n    width: 100%;\n}\n\n\n/* apply both justify and align in 'flex-center', for convenience */\n.op-flex.flex-center {\n    justify-content: center;\n    align-items: center;\n}\n\n\n/* container level justification properties. the 'just' keyword is left out of most selectors for ease of use */\n.op-flex.flex-start {\n    justify-content: flex-start;\n}\n\n.op-flex.flex-end {\n    justify-content: flex-end;\n}\n\n.op-flex.flex-between {\n    justify-content: space-between;\n}\n\n.op-flex.flex-even {\n    justify-content: space-evenly;\n}\n\n.op-flex.flex-around {\n    justify-content: space-around;\n}\n\n.op-flex.flex-just-center {\n    justify-content: center;\n}\n\n.op-flex.flex-just-stretch {\n    justify-content: stretch;\n}\n\n.op-flex.flex-just-normal {\n    justify-content: normal;\n}\n\n\n/* container level alignment properties */\n.op-flex.flex-align-start {\n    align-items: flex-start;\n}\n\n.op-flex.flex-align-end {\n    align-items: flex-end;\n}\n\n.op-flex.flex-align-center {\n    align-items: center;\n}\n\n.op-flex.flex-align-stretch {\n    align-items: stretch;\n}\n\n.op-flex.flex-align-baseline {\n    align-items: baseline;\n}\n\n.op-flex.flex-align-normal {\n    align-items: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
